// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row-container {\n  display: flex;\n  margin: 0;\n  color: var(--text-color-dark);\n}\n", ""]);
// Exports
module.exports = exports;
